__turbopack_context__.v({
  "buttonWrapper": "WhatsNewAnnouncement-module__Ab-f2G__buttonWrapper",
  "imageWrapper": "WhatsNewAnnouncement-module__Ab-f2G__imageWrapper",
  "whatsNewWrapper": "WhatsNewAnnouncement-module__Ab-f2G__whatsNewWrapper",
});
